const {
  VITE_SENTRY_ENV,
  VITE_SENTRY_KEY,
  VITE_SENTRY_SERVER_NAME,
  VITE_DASHBOARD_API_URL,
  VITE_DASHBOARD_API_PATH,
  VITE_API_TIMEOUT_MS,
} = import.meta.env;

const IS_PRODUCTION_ENVIRONMENT = VITE_SENTRY_ENV && VITE_SENTRY_ENV.toLowerCase() === "production";
const IS_PRODUCTION_BUILD = import.meta.env.PROD;
const IS_DEBUG_ENABLED = import.meta.env.VITE_DEBUG === "1";

const DASHBOARD_API_URL = VITE_DASHBOARD_API_URL;
const DASHBOARD_API_PATH = VITE_DASHBOARD_API_PATH;

const API_TIMEOUT_MS = VITE_API_TIMEOUT_MS;

const SENTRY_ENV = VITE_SENTRY_ENV;
const SENTRY_KEY = VITE_SENTRY_KEY;
const SENTRY_SERVER_NAME = VITE_SENTRY_SERVER_NAME;

const IS_ENABLED_REPORTS = import.meta.env.VITE_ENABLE_REPORTS === "1";

if (IS_DEBUG_ENABLED) {
  (window as any)._env = import.meta.env;
}

export {
  IS_PRODUCTION_ENVIRONMENT,
  IS_PRODUCTION_BUILD,
  IS_ENABLED_REPORTS,
  IS_DEBUG_ENABLED,
  DASHBOARD_API_URL,
  DASHBOARD_API_PATH,
  API_TIMEOUT_MS,
  SENTRY_ENV,
  SENTRY_KEY,
  SENTRY_SERVER_NAME,
};
